import { IOffer } from '../../../types/offer';

export interface ICommercialBSCTitle {
  text: string;
  url?: string;
}

export function getCommercialBSCTitle(offer: IOffer): ICommercialBSCTitle | undefined {
  if (offer.coworking?.name) {
    return {
      text: offer.coworking.name,
      url: offer.coworking.url,
    };
  }

  const bsc = offer.businessShoppingCenter;

  if (!bsc) {
    return undefined;
  }

  const name = bsc.useParentName && bsc.parentName ? bsc.parentName : bsc.name;

  if (!name) {
    return undefined;
  }

  return {
    text: name,
    url: bsc.useParentName ? bsc.parentUrl : bsc.fullUrl,
  };
}
